var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(!_vm.loading_task && _vm.one_task.id)?_c('dialog-one-task',{attrs:{"existing_task":_vm.one_task,"form_id":_vm.one_task.form_id},on:{"doneSchedule":_vm.handleDoneTask,"close":_vm.handleCloseTask}}):_vm._e(),(_vm.loading_task)?_c('dialog-loading'):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }